import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Typography, Button } from '@mui/material';
import axiosInstance from "../Service/axiosInstance";

function Header({ user, setUser }) {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [typeOffre, setTypeOffre] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Récupération des offres
  useEffect(() => {
    axiosInstance
      .get("/yourtravelshop/typeOffre/liste")
      .then((response) => setTypeOffre(response.data))
      .catch((error) => console.error("Erreur lors de la récupération des offres :", error));
  }, []);

  // Fermer le menu déroulant si clic en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Navigation
  const handleClickHome = () => navigate('/Home');
  const handleClickAbout = () => navigate('/About');
  const handleClickOffres = () => navigate('/Offres');

  // Scroll vers sections
  const toggleDropdownOffre = () => {
    const section = document.getElementById('type-offres-footer');
    if (section) section.scrollIntoView({ behavior: 'smooth' });
  };

  const handleClickContact = (e) => {
    e.preventDefault();
    const footer = document.getElementById('contact_messagerie');
    if (footer) footer.scrollIntoView({ behavior: 'smooth' });
  };

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Déconnexion
  const handleClickLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setUser(null); // met à jour le user dans App.js
    navigate('/Home');
  };

  const isLoggedIn = user !== null;
  return (
    <div>
      <header className="header">
        <div className="top_bar" style={{ height: "50px"}}>
          <div className="container">
            <div className="row">
              <div className="col d-flex flex-row align-items-center justify-content-between">
                <div className="social">
                    <ul
  className="social_list"
  style={{ display: 'flex', gap: '16px', listStyle: 'none', padding: 0, margin: 0 }}
>
  <li
    className="social_list_item"
    style={{ height: '48px', width: '48px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
  >
    <a
      href="https://www.facebook.com/people/Your-Travel-Shop/61556457474196"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}
    >
      <i
        className="fa fa-facebook"
        aria-hidden="true"
        style={{ fontSize: '20px' }}
      ></i>
    </a>
  </li>
  <li
    className="social_list_item"
    style={{ height: '48px', width: '48px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
  >
  </li>
                </ul>
                </div>
                <div className="user_box ml-auto">
                  {!isLoggedIn ? (
                    <>
                      <div className="user_box_login user_box_link">
                        <Button
                          variant="contained"
                          onClick={() => navigate('/Login')}
                          style={{
                            background: 'linear-gradient(to right, #fa9e1b, #8d4fff, #fa9e1b)',
                            color: 'white',
                            fontWeight: 'bold',
                            padding: '4px 7px',
                            fontSize: '14px',
                            borderRadius: '15px',
                          }}
                        >
                          Se connecter
                        </Button>
                      </div>
                      <div className="user_box_register user_box_link">
                        <Button
                          variant="contained"
                          onClick={() => navigate('/Inscription')}
                          style={{
                            backgroundColor: 'rgba(54, 19, 84, 0.85)',
                            color: 'white',
                            fontWeight: 'bold',
                            padding: '4px 7px',
                            fontSize: '14px',
                            borderRadius: '15px',
                          }}
                        >
                          S'inscrire
                        </Button>
                      </div>
                    </>
                  ) : (
                    <div className="user_box_logout user_box_link">
                      {user && (
                        <div
                          className="user_info"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px',
                            transition: 'all 0.3s ease',
                          }}
                        >
                          <Button
  onClick={() => navigate(`/espace-client`)}
  style={{
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    padding: '6px 12px',
    fontSize: '14px',
    borderRadius: '15px',
    gap: '10px',
    color: 'white',
    textTransform: 'none',
    transition: 'color 0.3s ease, transform 0.3s ease',
  }}
  onMouseEnter={(e) => (e.currentTarget.style.color = '#fa9e1b')}
  onMouseLeave={(e) => (e.currentTarget.style.color = 'white')}
>
                            <img
                              src={`${process.env.PUBLIC_URL}/assets/images/client.png`}
                              alt="Client"
                              width="50"
                              height="50"
                              style={{ borderRadius: '50%' }}
                            />
                            <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                              <Typography variant="body1" style={{ fontWeight: 'bold' }}>{user.nom}</Typography>
                              <Typography variant="body2">{user.prenom}</Typography>
                            </div>
                          </Button>

                          <Button
                            variant="contained"
                            onClick={handleClickLogout}
                            style={{
                              background: 'linear-gradient(to right, #fa9e1b, #8d4fff, #fa9e1b)',
                              color: 'white',
                              fontWeight: 'bold',
                              padding: '6px 12px',
                              fontSize: '14px',
                              borderRadius: '15px',
                              transition: 'background 0.3s ease, transform 0.3s ease',
                              textTransform: 'none',
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                          >
                            Se déconnecter
                          </Button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <nav className="main_nav">
  <div className="container">
    <div className="row" style={{ height: "50px"}}>
      <div
        className="col main_nav_col d-flex flex-row align-items-center justify-content-start"
        style={{ height: "100%", paddingTop: '5px', paddingBottom: '5px' }}
      >
        <div className="logo_container">
          <div className="logo">
              <Link
  className="nav-link"
  to="/Home"
  onClick={handleClickHome}
  style={{ display: 'flex', alignItems: 'center' }}
>
  <img
    src={`${process.env.PUBLIC_URL}/assets/images/logoH.png`}
    alt="Logo"
    width="35px"
    height="auto"
  />
  <span
    style={{
      fontFamily: 'Dancing Script, cursive',
      fontSize: '30px',
      marginLeft: '5px',
      textTransform: 'none',
      wordSpacing: '7px',
    }}
  >
    Your Travel Shop
  </span>
          </Link>          </div>
        </div>

        <div className="main_nav_container ml-auto">
          <ul className="main_nav_list" style={{ gap: "8px", fontSize: "14px" }}>
            <li className="main_nav_item"><a href="#" onClick={handleClickHome}>Accueil</a></li>
            <li className="main_nav_item" style={{ position: 'relative' }}  ref={dropdownRef}>
              <a href="" onClick={toggleDropdown}>Nos Offres</a>
              <ul
                style={{
                  display: isDropdownOpen ? "block" : "none",
                  position: "absolute",
                  background: 'linear-gradient(to right, #fa9e1b, #8d4fff, #fa9e1b)',
                  listStyleType: "none",
                  padding: "8px",
                  marginTop: "5px",
                  borderRadius: "5px",
                  boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
                  minWidth: "180px",
                  zIndex: 1000,
                }}
              >
                {typeOffre.length > 0 ? (
                  typeOffre.map((offre) => (
                    <li
                      key={offre.id}
                      onClick={() => navigate(`/type-offres/${offre.id}`)}
                      style={{
                        cursor: "pointer",
                        marginBottom: "4px",
                        color: "white",
                        fontSize: "13px",
                      }}
                    >
                      {offre.nom}
                    </li>
                  ))
                ) : (
                  <li style={{ fontSize: "13px" }}>Aucune offre disponible</li>
                )}
              </ul>
            </li>
            <li className="main_nav_item"><a href="#" onClick={handleClickAbout}>A propos</a></li>
            <li className="main_nav_item">
              <a href="#contact_messagerie" onClick={handleClickContact}>Contact</a>
            </li>
          </ul>
        </div>

        <div className="hamburger" style={{ marginLeft: "auto", paddingRight: "10px" }}>
          <i className="fa fa-bars trans_200" style={{ fontSize: "20px" }}></i>
        </div>
      </div>
    </div>
  </div>
        </nav>

      </header>
        <div className="menu trans_500">
          <div className="menu_content d-flex flex-column align-items-center justify-content-center text-center">
            
            {/* Bouton de fermeture */}
            <div className="menu_close_container">
              <div className="menu_close" />
            </div>

            {/* Logo */}
            <div className="logo menu_logo">
            <a href="#" onClick={handleClickHome}>
                <img src="assets/images/logoH.png" alt="Logo" />
            </a>
            </div>

            {/* Menu */}
            <ul>
  <li className="menu_item">
  <a href="#" onClick={handleClickHome}> Accueil </a>
  </li>
  <li className="menu_item" style={{ position: "relative" }}>
    <a onClick={handleClickOffres} style={{ cursor: 'pointer', color: 'white' }}>
      Nos Offres
    </a>
  </li>
  <li className="menu_item">
    <a onClick={handleClickAbout} style={{ cursor: 'pointer', color: 'white' }}>
      À propos
    </a>
  </li>
  <li className="menu_item">
    <a onClick={handleClickContact} style={{ cursor: 'pointer', color: 'white' }}>
      Contact
    </a>
  </li>

  {/* Zone Utilisateur */}
  {!isLoggedIn ? (
    <>
      <li className="menu_item">
      <a onClick={() => navigate('/Login')} style={{ cursor: 'pointer', color: 'white' }} >
          Se connecter
        </a>
      </li>
      <li className="menu_item">
      <a onClick={() => navigate('/Inscription')} style={{ cursor: 'pointer', color: 'white' }}>
          S'inscrire
      </a>
      </li>
    </>
  ) : (
    <>
      <li className="menu_item">
      <a onClick={() => navigate('/espace-client')} style={{ color: 'black', cursor: 'pointer' }}>
  {user.nom} {user.prenom}
</a>

      </li>
      <li className="menu_item">
      <a onClick={handleClickLogout} style={{ cursor: 'pointer', color: 'white' }}>
          Se déconnecter
      </a>
      </li>
    </>
  )}
            </ul>

          </div>
        </div>


    </div>
  );
}

export default Header;
